(() => {
  const config = JSON.parse(document.getElementById('BKConfig')?.textContent || '{}');
  const root = window.Shopify?.routes?.root || '/';
  const status = document.getElementById('BKStatus');
  let quickRequest;
  let quickTrigger;
  let reduced = false;
  try { reduced = localStorage.getItem('bk-ranch-motion') === 'reduce'; } catch {}
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 900px) and (min-height: 761px)');
  let frame = 0;
  let scenes = [];
  let revealObserver;
  const setMotion = () => {
    document.documentElement.classList.toggle('reduce-motion', reduced);
    document.querySelectorAll('[data-bk-motion]').forEach(button => {
      button.setAttribute('aria-pressed', String(reduced));
      button.textContent = reduced ? config.restore : config.reduce;
    });
  };
  const renderMotion = () => {
    frame = 0;
    document.querySelector('.site-header')?.classList.toggle('is-scrolled', scrollY > 80);
    scenes.forEach(scene => {
      const rect = scene.getBoundingClientRect();
      const denominator = scene.dataset.motion === 'ritual' ? Math.max(1, rect.height - innerHeight) : rect.height;
      const progress = Math.max(0, Math.min(1, -rect.top / denominator));
      scene.style.setProperty('--progress', reduced || motion.matches || !desktop.matches ? '1' : progress.toFixed(4));
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(renderMotion); };
  const initMotion = () => {
    scenes = Array.from(document.querySelectorAll('[data-motion]'));
    revealObserver?.disconnect();
    if ('IntersectionObserver' in window) {
      revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); }
      }), { threshold: .08, rootMargin: '0px 0px -24px 0px' });
      document.querySelectorAll('[data-reveal]').forEach(element => revealObserver.observe(element));
      document.documentElement.classList.add('motion-ready');
    }
    setMotion(); renderMotion();
  };
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  motion.addEventListener('change', schedule);
  desktop.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', initMotion);
  document.addEventListener('close', event => {
    if (event.target.id === 'BKNavigation') document.querySelector('[data-bk-menu]')?.setAttribute('aria-expanded', 'false');
    if (event.target.id === 'BKQuickView') quickRequest?.abort();
  }, true);
  document.addEventListener('click', async event => {
    const menu = event.target.closest('[data-bk-menu]');
    if (menu) { document.getElementById('BKNavigation')?.showModal(); menu.setAttribute('aria-expanded', 'true'); return; }
    const close = event.target.closest('[data-bk-close]');
    if (close) { close.closest('dialog')?.close(); return; }
    const dialog = event.target.closest('dialog');
    if (dialog && event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
    const motionButton = event.target.closest('[data-bk-motion]');
    if (motionButton) {
      reduced = !reduced;
      try { localStorage.setItem('bk-ranch-motion', reduced ? 'reduce' : 'default'); } catch {}
      setMotion(); schedule(); return;
    }
    const tab = event.target.closest('[data-bk-tabs] [role="tab"]');
    if (tab) { selectTab(tab); return; }
    const link = event.target.closest('[data-bk-quick]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
    const quick = document.getElementById('BKQuickView');
    if (!quick || !('showModal' in quick)) return;
    event.preventDefault();
    quickRequest?.abort();
    const request = new AbortController();
    quickRequest = request; quickTrigger = link;
    const content = quick.querySelector('[data-bk-quick-content]');
    const loading = document.createElement('div');
    loading.className = 'bk-loading'; loading.id = 'BKQuickTitle'; loading.textContent = config.loading;
    content.replaceChildren(loading);
    quick.showModal();
    try {
      const url = new URL(link.href, location.origin);
      url.searchParams.set('section_id', 'bk-quick-view');
      const response = await fetch(url, { signal: request.signal });
      if (!response.ok) throw new Error('Product unavailable');
      const html = await response.text();
      if (quickRequest !== request || !quick.open) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const productContent = parsed.querySelector('.bk-quick-content');
      if (!productContent) throw new Error('Product unavailable');
      content.replaceChildren(productContent);
      quick.querySelector('.bk-dialog-close')?.focus();
    } catch (error) {
      if (error.name !== 'AbortError') { quick.close(); location.assign(link.href); }
    }
  });
  function selectTab(tab) {
    const tabs = tab.closest('[data-bk-tabs]');
    tabs.querySelectorAll('[role="tab"]').forEach(item => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.dataset.state = active ? 'active' : 'inactive';
      item.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
    });
  }
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-bk-tabs] [role="tab"]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
    const position = tabs.indexOf(tab);
    const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (position + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    selectTab(tabs[index]); tabs[index].focus();
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.bk-add-form');
    if (!form) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer?.renderContents) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled || form.dataset.busy === 'true') return;
    const errorMessage = form.querySelector('.bk-form-error');
    form.dataset.busy = 'true'; button.disabled = true; button.setAttribute('aria-busy', 'true');
    errorMessage.hidden = true;
    try {
      const data = new FormData(form);
      data.append('sections', 'cart-drawer,cart-icon-bubble');
      data.append('sections_url', location.pathname);
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
      const cartData = await response.json();
      if (!response.ok || cartData.status) throw new Error(cartData.description || cartData.message || config.error);
      const quick = document.getElementById('BKQuickView');
      const trigger = quick?.open ? quickTrigger : button;
      quick?.close();
      drawer.setActiveElement(trigger);
      if (!cartData.sections?.['cart-drawer'] || !cartData.sections?.['cart-icon-bubble']) { location.assign(root + 'cart'); return; }
      drawer.renderContents(cartData);
      drawer.classList.remove('is-empty');
      if (status) status.textContent = document.querySelector('.drawer__heading')?.textContent || '';
    } catch (error) {
      errorMessage.textContent = error.message || config.error; errorMessage.hidden = false;
      if (status) status.textContent = errorMessage.textContent;
    } finally {
      delete form.dataset.busy; button.disabled = false; button.removeAttribute('aria-busy');
    }
  });
  initMotion();
})();
